import * as tslib_1 from "tslib";
import './masonry.less';
import { m } from '../hyperscript';
import { View } from './view';
var Masonry = /** @class */ (function (_super) {
    tslib_1.__extends(Masonry, _super);
    function Masonry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Masonry.prototype.divide = function (items, colsCount) {
        var cols = Array(colsCount)
            .fill(null)
            .map(function (_) { return []; });
        items.forEach(function (item, i) {
            var col = i % colsCount;
            cols[col].push(item);
        });
        return cols;
    };
    Masonry.prototype.render = function () {
        var _a = this.attrs, children = _a.children, colsCount = _a.cols;
        var cols = this.divide(children, colsCount);
        return (m("div", tslib_1.__assign({ class: "masonry" }, cols.map(function (children, i) { return (m("div", { class: "masonry-col", style: {
                flexBasis: 100 / cols.length + '%'
            } }, children.map(function (item, j) { return (m("div", { class: "masonry-item" }, item)); }))); }))));
    };
    return Masonry;
}(View));
export { Masonry };
